const ProfileLinks = [
  {
    name: "01 Basic Information",
    url: "/profile/basicInfo",
  },
  {
    name: "02 Official Info",
    url: "/profile/official",
  },
  {
    name: "03 Emergency Contact",
    url: "/profile/emergency",
  },
  // {
  //   name: "04 Educational Info",
  //   url: "/profile/education",
  // },
  {
    name: "04 Bank Info",
    url: "/profile/bank",
  },
];

const Gender = [
  {
    sex: "Male",
    value: "Male",
  },
  {
    sex: "Female",
    value: "Female",
  },
];

const States = [
  { value: "Abia" },
  { value: "Adamawa" },
  { value: "Akwa Ibom" },
  { value: "Anambra" },
  { value: "Bauchi" },
  { value: "Bayelsa" },
  { value: "Benue" },
  { value: "Cross River" },
  { value: "Delta" },
  { value: "Ebonyi" },
  { value: "Edo" },
  { value: "Ekiti" },
  { value: "Enugu" },
  { value: "FCT" },
  { value: "Gombe" },
  { value: "Imo" },
  { value: "Jigawa" },
  { value: "Kaduna" },
  { value: "Kano" },
  { value: "Katsina" },
  { value: "Kebbi" },
  { value: "Kogi" },
  { value: "Kwara" },
  { value: "Lagos" },
  { value: "Nasarawa" },
  { value: "Niger" },
  { value: "Ogun" },
  { value: "Ondo" },
  { value: "Osun" },
  { value: "Oyo" },
  { value: "Plateau" },
  { value: "Rivers" },
  { value: "Sokoto" },
  { value: "Taraba" },
  { value: "Yobe" },
  { value: "Zamfara" },
];

const Departments = [
  { value: "Business Solutions" },
  { value: "Infrastructure" },
  { value: "Data and AI" },
  { value: "Finance" },
  { value: "Human Resource and Administration" },
];

const Months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const Banks = [
  { value: "Access Bank" },
  { value: "Citibank" },
  { value: "Diamond Bank" },
  { value: "Ecobank" },
  { value: "Fidelity Bank" },
  { value: "First Bank" },
  { value: "First City Monument Bank" },
  { value: "Guaranty Trust Bank" },
  { value: "Heritage Bank" },
  { value: "Keystone Bank" },
  { value: "MainStreet Bank" },
  { value: "Polaris Bank" },
  { value: "Stanbic IBTC Bank" },
  { value: "Standard Chartered Bank" },
  { value: "Sterling Bank" },
  { value: "Union Bank" },
  { value: "United Bank For Africa" },
  { value: "Unity Bank" },
  { value: "Wema Bank" },
  { value: "Zenith Bank" },
];

const Locations = [{ value: "Abuja" }, { value: "Lagos" }, { value: "Others" }];

const Quarters = [
  // "First Quarter",
  "Second Quarter",
  // "Third Quarter",
  "Fourth Quarter",
];

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ProfileLinks,
  Gender,
  States,
  Departments,
  Locations,
  Months,
  Banks,
  Quarters,
};
